import { memo } from 'react';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  model: CheckoutConfirmationResponseType['GiftAidSubsection'];
};

export const CheckoutConfirmationGiftAid = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.giftAid');

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <div className="card hoverable summary">
        <table className="table word-break-last-td-column">
          <tbody>
            <tr>
              <td className="roboto-medium">{tHelper('title')}</td>
              <td>
                <div>
                  {tHelper('text', {
                    singular: model.ContributionTerminology.Singular?.toLowerCase() || '',
                    name: model.OrganizationCommonName || '',
                  })}
                </div>
              </td>
            </tr>
            <tr>
              <td className="roboto-medium white-space-nowrap">{tHelper('yourName')}</td>
              <td>
                <span>{model.GiftAidTitle}</span>
                <span>{model.GiftAidFirstName}</span>
                <span>{model.GiftAidLastName}</span>
              </td>
            </tr>
            <tr>
              <td className="roboto-medium">{tHelper('address')}</td>
              <td>
                <div>{model.GiftAidAddressLine1}</div>
                {model.GiftAidAddressLine2 && <div>{model.GiftAidAddressLine2}</div>}
                {model.GiftAidAddressLine3 && <div>{model.GiftAidAddressLine3}</div>}
                <div>
                  {model.GiftAidCity} {model.GiftAidPostalCode}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
});
